module.exports = __webpack_public_path__ + "static/media/0025_IMG_LE_POISSONNIER.e95d0f4a.png";